<template>
  <el-card
    class="task-notice"
    shadow="never"
  >
    <!-- 创建通知 -->
    <el-tabs
      v-model="currentTab"
      class="notice-tabs"
    >
      <el-tab-pane label="创建通知">
        <el-form
          ref="noticeForm"
          label-width="80px"
          :model="noticeForm"
          :rules="rules"
        >
          <el-form-item
            label="发送至"
            prop="surveyorIds"
          >
            <el-select
              v-model="noticeForm.surveyorIds"
              multiple
              placeholder="请选择"
              class="select-surveyorIds"
              @change="selectChange"
            >
              <el-option
                v-for="surveyor in surveyors"
                :key="surveyor.id"
                :label="surveyor.name"
                :value="surveyor.id"
              >
                <span class="option-left">{{ surveyor.name }}</span>
                <span class="option-right">{{ surveyor.mobile }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="通知标题"
            prop="title"
          >
            <el-input
              v-model.trim="noticeForm.title"
              placeholder="请输入通知标题"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="通知内容"
            prop="content"
          >
            <el-input
              v-model.trim="noticeForm.content"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 10}"
              resize="none"
              placeholder="请输入通知内容"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="reset">重置</el-button>
            <el-button
              type="primary"
              :loading="loading"
              @click="sendNotice"
            >发送</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 通知列表 -->
      <el-tab-pane
        label="通知列表"
        class="notice-list_pane"
      >
        <el-table
          height="100%"
          border
          :data="tableData"
          :header-cell-style="tableStyle"
        >
          <el-table-column
            type="index"
            width="50"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="title"
            label="标题"
          >
          </el-table-column>
          <el-table-column
            prop="content"
            label="内容"
          >
          </el-table-column>
          <el-table-column
            label="接收人数"
            width="100"
            align="center"
          >
            <template #default="{row}">
              共 {{row.surveyors.length}} 人
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="180"
            align="center"
          >
            <template #default="{row}">
              <el-button
                type="primary"
                icon="el-icon-edit"
                size="mini"
                plain
                @click="showModifyDialog(row)"
              >修改</el-button>
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                plain
                @click="deleteNotice(row.id)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <!-- 修改通知弹窗 -->
    <modify-notice
      :show.sync="show"
      :data="modifyData"
      @success="modifySuccess"
    ></modify-notice>
  </el-card>
</template>

<script>
import { getSurveyors } from "@/api/surveyors";
import { sendNotice, deleteNotice, getNotices } from "@/api/notice";
import ModifyNotice from "./components/modify-notice";
import tableStyle from "./components/tableStyle";
export default {
  data() {
    return {
      //当前tab页的下标
      currentTab: "0",
      //发送按钮的loading状态
      loading: false,
      //是否显示修改弹窗
      show: false,
      //需要修改的通知的数据
      modifyData: {},
      //创建通知的表单数据
      noticeForm: {
        title: "",
        content: "",
        surveyorIds: []
      },
      //通知接收者列表
      surveyors: [],
      //noticeForm.surveyorIds的上一次选择记录
      oldSelect: [],
      //通知表单的验证规则
      rules: {
        surveyorIds: [
          {
            required: true,
            message: "请选择通知的接收者",
            trigger: "change"
          }
        ],
        title: [
          {
            required: true,
            message: "请输入通知标题",
            trigger: "blur"
          }
        ],
        content: [
          {
            required: true,
            message: "请输入通知内容",
            trigger: "blur"
          }
        ]
      },
      //通知列表的样式
      tableStyle,
      //通知列表的数据
      tableData: []
    };
  },
  computed: {
    //问卷id
    id() {
      return this.$route.params.id;
    },
    //除了“所有人”选项的ids集合，表示全选状态下的id
    rawIds() {
      return this.surveyors.filter(surveyor => surveyor.id !== -1);
    }
  },
  mounted() {
    this.getSurveyors();
    this.getNotices();
  },
  methods: {
    //发送通知
    async sendNotice() {
      let valid = await this.validate();
      //验证不通过
      if (!valid) return;
      this.loading = true;
      const { title, content } = this.noticeForm;
      //去除id为-1的选项
      const surveyorIds = this.noticeForm.surveyorIds.filter(id => id !== -1);
      sendNotice({
        surveyId: this.id,
        title,
        content,
        surveyorIds
      })
        .then(() => {
          this.getNotices(); //刷新列表
          this.$message({
            type: "success",
            message: "通知发送成功",
            duration: 1500,
            center: true
          });
          this.reset(); //重置表单
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "通知发送失败",
            duration: 1500,
            center: true
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //打开修改通知的弹窗
    showModifyDialog(data) {
      this.modifyData = data;
      this.show = true;
    },
    //删除通知
    deleteNotice(id) {
      this.$confirm("此操作将永久删除该通知, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        callback: action => {
          if (action === "confirm") {
            deleteNotice(id).then(() => {
              this.$message({
                type: "success",
                message: "删除成功",
                duration: 1500,
                center: true
              });
              this.getNotices();
            });
          }
        }
      });
    },
    //根据问卷id查通知列表
    getNotices() {
      return getNotices({
        surveyId: this.id
      }).then(res => {
        this.tableData = res.data;
      });
    },
    //查询通知接收人员的列表
    getSurveyors() {
      getSurveyors().then(res => {
        this.surveyors = res.data;
        this.surveyors.unshift({
          id: -1,
          name: "所有人",
          mobile: "选中后通知将发送给所有调查员"
        });
      });
    },
    //接收人员改变
    selectChange(ids) {
      const oldHasAll = this.oldSelect.includes(-1); //上次选中记录有没有全选
      const currentHasAll = ids.includes(-1); //本次选中记录有没有全选
      //如果选择了全选
      if (!oldHasAll && currentHasAll) {
        const allIds = this.surveyors.map(surveyor => surveyor.id); //全部选中时候的选项
        this.$set(this.noticeForm, "surveyorIds", allIds);
      }
      //取消全选
      if (oldHasAll && !currentHasAll) {
        this.$set(this.noticeForm, "surveyorIds", []);
      }
      //有全选的情况下选择了其它选项
      if (oldHasAll && currentHasAll) {
        const index = this.noticeForm.surveyorIds.indexOf(-1);
        this.$delete(this.noticeForm.surveyorIds, index);
      }
      //当前没有选择全选并且选择了所有选项
      if (
        !currentHasAll &&
        this.noticeForm.surveyorIds.length === this.rawIds.length
      ) {
        this.noticeForm.surveyorIds.unshift(-1);
      }
      //将本次选择保存，方便比对
      this.oldSelect = [...this.noticeForm.surveyorIds];
    },
    //修改通知成功
    modifySuccess() {
      //刷新列表然后关闭弹窗
      this.getNotices().then(() => {
        this.$message({
          type: "success",
          message: "修改成功",
          duration: 1500,
          center: true
        });
        this.show = false;
      });
    },
    //表单验证
    validate() {
      return new Promise(resolve => {
        this.$refs.noticeForm.validate(valid => {
          resolve(valid);
        });
      });
    },
    //重置表单
    reset() {
      this.$refs.noticeForm.resetFields();
    }
  },
  components: {
    ModifyNotice
  }
};
</script>

<style lang="less" scoped>
.task-notice {
  // padding: 0 20px 20px;
  background-color: #fff;
  height: 100%;
}
.select-surveyorIds {
  width: 100%;
}
.option-left {
  float: left;
}
.option-right {
  float: right;
  color: #8492a6;
  font-size: 13px;
  margin-right: 40px;
}
.notice-tabs {
  height: 100%;
  .el-tabs__content {
    height: calc(100% - 55px);
  }
}
.notice-list_pane {
  height: 100%;
}
</style>